// import React from "react";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";

function Footer() {
  return (
    <div className="bg-[#FFF9F9] py-14 flex flex-col">
      <div className="container mx-auto px-10 grid grid-cols-1 mb-6 md:grid-cols-4 gap-10 text-left">
        {/* Column 1: Logo */}
        <div className="space-y-5">
          <h1 className="text-2xl font-bold text-primary">LOGO</h1>
          <p>
            It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout.
          </p>
          <div className="flex gap-3">
            <div className="flex items-center justify-center w-10 h-10 text-primary rounded-full bg-red-200 text-lg">
              <FaFacebookF />
            </div>
            <div className="flex items-center justify-center w-10 h-10 text-primary rounded-full bg-red-200 text-lg">
              <FaLinkedinIn />
            </div>
            <div className="flex items-center justify-center w-10 h-10 text-primary rounded-full bg-red-200 text-lg">
              <FaTwitter />
            </div>
          </div>
        </div>

        {/* Column 2: Useful Links */}
        <div className="space-y-5">
          <h1 className="text-2xl font-bold text-black">Useful Links</h1>
          <ul className="space-y-2">
            <li>Home</li>
            <li>About</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* Column 3: Contact */}
        <div className="space-y-5">
          <h1 className="text-2xl font-bold text-black">Contact Us</h1>
          <ul className="space-y-2">
            <li>Email: example@example.com</li>
            <li>Phone: +123 456 789</li>
            <li>Address: 123 Street, City</li>
          </ul>
        </div>

        {/* Column 4: Subscribe */}
        {/* Column 4: Subscribe */}
        <div className="space-y-5 relative">
          <h1 className="text-2xl font-bold text-black">Subscribe Us</h1>
          <p>Stay update with us and get offer!</p>
          <div className="relative">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none"
            />
            <button className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary-dark">
              Subscribe
            </button>
          </div>
        </div>
      </div>
      <div className="text-center mt-10 text-gray-500 border-t border-gray-300 pt-5">
        <p> Copyright &copy; 2021 All Rights Reserved</p>
      </div>
    </div>
  );
}

export default Footer;
